export { TestimonialWall as TestimonialCarouselSection } from "../cms-collections"
export type { TestimonialWallProps as TestimonialCarouselSectionProps } from "../cms-collections"